// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faqCollapseButton,
.faqCollapseButton:hover,
.faqCollapseButton:focus {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    padding: 0;
    background: transparent;
    border: unset;
    border-radius: 6px;
    outline: unset;
    box-shadow: unset;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    text-align: start;
    color: var(--primary-foreground);
}

.faqCollapseButtonContainer {
    border: 1px solid var(--primary-border);
    border-radius: 6px;
    margin-bottom: 25px;
    padding: 30px;
    text-align: start;
}

.faqCollapseButtonContainer .faqCollapseButton>svg {
    width: 22px;
    height: 22px;
    object-fit: contain;
    transition: all 0.4s linear;
}

.faqCollapseButtonContainerOpen .faqCollapseButton>svg {
    transform: rotate(180deg);
    transition: all 0.4s linear;
}

.faqCollapseBody {
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
}

.faqCollapseBodyWrapper {
    padding-top: 12px;
    color: var(--secondary-foreground);
}`, "",{"version":3,"sources":["webpack://./src/styles/customReactCollapse.css"],"names":[],"mappings":"AAAA;;;IAGI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;AACtC","sourcesContent":[".faqCollapseButton,\n.faqCollapseButton:hover,\n.faqCollapseButton:focus {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 6px;\n    padding: 0;\n    background: transparent;\n    border: unset;\n    border-radius: 6px;\n    outline: unset;\n    box-shadow: unset;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: normal;\n    text-align: start;\n    color: var(--primary-foreground);\n}\n\n.faqCollapseButtonContainer {\n    border: 1px solid var(--primary-border);\n    border-radius: 6px;\n    margin-bottom: 25px;\n    padding: 30px;\n    text-align: start;\n}\n\n.faqCollapseButtonContainer .faqCollapseButton>svg {\n    width: 22px;\n    height: 22px;\n    object-fit: contain;\n    transition: all 0.4s linear;\n}\n\n.faqCollapseButtonContainerOpen .faqCollapseButton>svg {\n    transform: rotate(180deg);\n    transition: all 0.4s linear;\n}\n\n.faqCollapseBody {\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.faqCollapseBodyWrapper {\n    padding-top: 12px;\n    color: var(--secondary-foreground);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
